import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Box, Button, FormControl, MenuItem, Select } from "@mui/material";
import DarkLightModeButton from "./dark-light-mode-button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthenticationButton } from "../../main/auth";

export default function Header() {
  const { t, i18n } = useTranslation();

  const handleChange = (event) => {
    const language = event.target.value;
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
  };

  const age = i18n.language;

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          <Link style={{ textDecoration: "none", color: "inherit" }} to="/main">
            Wyes Cloud
          </Link>
        </Typography>
        <Box sx={{ flexGrow: 1, textAlign: "right" }}>
          <AuthenticationButton />
          <FormControl sx={{ mx: 1 }} size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"en"}>EN</MenuItem>
              <MenuItem value={"fr"}>FR</MenuItem>
            </Select>
          </FormControl>
          <DarkLightModeButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
